import { api } from "../store/middleware/api"

const extendedApi = api.injectEndpoints({
    endpoints: (build) => ({
        search: build.mutation({
            query: (body) => ({
                // url: "/auth/search",
                url: "/auth/search",
                method: "POST",
                body
            })
        })
    }),
    overrideExisting: false,
})

export const { useSearchMutation } = extendedApi